import { useEffect } from 'react'

import { useZero } from '@rocicorp/zero/react'

import { homeTasksListQuery } from '#features/home/home-tasks-query.ts'

/**
 * Keeps the home "Needs attention" / "Recent" query warm via Zero preload so
 * opening Home (or returning to it) does not flash list skeletons.
 */
export function usePreloadHomeTasks(workspaceId: string) {
  const zero = useZero()

  useEffect(() => {
    const { cleanup } = zero.preload(homeTasksListQuery(workspaceId))
    return cleanup
  }, [zero, workspaceId])
}
